import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const FastBI = () => import('@/components/Help/FastBI');
const Index = () => import('@/components/Index')
const Login = () => import('@/components/Login/Login')
const VideoStudy = () => import('@/components/Study/VideoStudy')
const VideoModel = () => import('@/components/Study/VideoModel')
const Reset = () => import('@/components/Reset/Reset')
const Register = () => import('@/components/Register/Register')
const ModelTest = () => import('@/components/Test/ModelTest')
const Services = () => import('@/components/StaffService/Services')
const UserMenu = () => import('@/components/User/UserMenu')
const Home = () => import('@/components/Home/Home')
const Option = () => import('@/components/Option/Option')

const routes = [{
    path: '/index',
    component: Home,
    meta: {
      title: '天智数据'
    }
  },
  {
    // 首页
    path: '/',
    component: Home,
    meta: {
      title: '天智数据'
    }
  },
  {
    // 首页
    path: '/course/:id',
    component: Index,
    props: true,
    meta: {
      title: '天智数据-学习中心'
    }
  },
  // 登录
  {
    path: '/login',
    component: Login,
    meta: {
      title: '登录'
    }
  },
  // 学习视频
  {
    path: '/video',
    component: VideoStudy,
    children: [{
      path: '/video/:id',
      component: VideoModel,
      props: true,
      meta: {
        title: '学习视频'
      }
    }]
  },
  // 重置密码
  {
    path: '/reset',
    component: Reset,
    meta: {
      title: '重置密码'
    }
  },
  // 注册
  {
    path: '/register',
    component: Register,
    meta: {
      title: '注册'
    }
  },
  // 模拟考试
  {
    path: '/test/:id',
    component: ModelTest,
    props: true,
    meta: {
      title: '考试练习'
    }
  },
  // 客服中心
  {
    path: '/service',
    component: Services,
    meta: {
      title: '客服中心'
    }
  },
  // 用户菜单
  {
    path: '/user',
    component: UserMenu,
    meta: {
      title: '用户中心'
    }
  },
  {
    path: '/option',
    component: Option,
    meta: {
      title: '意见反馈',
      show:true
    }
  },
  {
    path: '/help',
    component: FastBI,
    meta: {
      title: '帮助文档',
      show:true
    }
  }
]
const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() {
    //滚动行为这个函数,需要有返回值,返回值为一个对象。
    //经常可以设置滚动条x|y位置 [x|y数值的设置一般最小是零]
    return { y: 0 };
}
})

router.beforeEach((to, from, next) => {
  // var reloaded = window.localStorage.getItem('reloaded') || ""
  var istoken = window.localStorage.getItem('token')
  // if (reloaded == "" && (to.path == "/reset" || to.path == "/register")) {
  //   next()
  //   window.location.reload();
  //   window.localStorage.setItem('reloaded', 'yes')
  // }

  if (!istoken && to.path == '/modeltest') {
    next('/login')
  }
  if (to.meta.title) {
    //判断是否有标题
    document.title = to.meta.title
  }
  // if(to.meta.content){
  //   let head = document.getElementsByTagName('head');
  //   let meta = document.createElement('meta');
  //   meta.content = to.meta.content;
  //   head[0].appendChild(meta)
  // }

  next()
})

export default router
